import {
  //retrieveMeasurements,
  storeMeasurements,
  downloadReport,
} from './dataExchange';
import isToolSupported from './utils/isToolSupported';

const DICOMSR = {
  //retrieveMeasurements,
  storeMeasurements,
  downloadReport,
  isToolSupported,
};

export default DICOMSR;
